<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          课程名称
        </div>
        <el-select
          v-model="searchForm.courseId"
          placeholder="请选择课程"
          clearable
          filterable
          @change="getList()"
        >
          <el-option
            v-for="course in courseList"
            :key="course.id"
            :label="course.courseName"
            :value="course.id"
          />
        </el-select>
      </div>
      <div class="r">
        <el-date-picker
          v-model="searchForm.scheduleDate"
          type="date"
          value-format="timestamp"
          placeholder="选择日期"
          @change="getList()"
        />
      </div>
    </div>
    <data-table
      :data="tabelData"
      :pagination="true"
      :table-column="tableColumn"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
  </div>
</template>

<script>
import { } from 'vuex';
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import { courseTypeList, classTypeList, liveStatusList } from '@/config';

// @ is an alias to /src

export default {
  name: 'Home',
  components: {
    dataTable,
  },
  data() {
    return {
      courseList: [],
      tabelData: {},
      searchForm: {
        courseId: '',
        scheduleDate: new Date().getTime(),
        pageNum: 1,
        pageSize: 10,
      },
      tableColumn: [
        {
          key: 'courseName',
          label: '课程名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseType',
          label: '课程类型',
          width: '80px',
          dataType: 'function',
          renderProps: '',
          render: (key) => courseTypeList.filter((item) => item.value === key),
        },
        {
          key: 'scheduleDate',
          label: '日期',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'classType',
          label: '时间',
          width: '80px',
          dataType: 'function',
          renderProps: '',
          render: (key) => classTypeList.filter((item) => item.value === key),
        },
        {
          key: 'totalMinute',
          label: '时间',
          width: '80px',
          unit: '分',
          dataType: 'text',
        },
        {
          key: 'liveStatus',
          label: '直播状态',
          width: '80px',
          dataType: 'function',
          renderProps: '',
          render: (key) => liveStatusList.filter((item) => item.value === key),
        },
        {
          key: 'control',
          label: '操作',
          width: 'auto',
          dataType: 'component',
          renderProps: [
            {
              text: '开启直播', renderKey: 0, renderProp: 'showBtn', type: 'success', eventIndex: 1, disableKey: null,
            },
            {
              text: '进入直播', renderKey: 1, renderProp: 'showBtn', type: 'primary', eventIndex: 2, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'searchForm.courseId': function(val) {
      if (val !== '') {
        this.searchForm.scheduleDate = null;
      }
    },
  },
  mounted() {
    this.getList();
    this.getCourseList();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.live.pageScheduleLive(this.searchForm);
      const { pageNum, pageSize, total } = result;
      result.list.forEach((item) => {
        this.$set(item, 'showBtn', item.courseLiveRecordId ? 1 : 0);
      });
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'LiveDetails', params: { id: item.courseLiveRecordId } });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 1:
          this.openLive(item);
          break;
        case 2:
          this.goDetails(item);
          break;
        default:
          break;
      }
    },
    // table 改变 pagination
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // 查询课程列表
    async getCourseList() {
      this.courseList = await axClient.cert.listCourseNameByCert();
    },
    // 禁用/启用 账号
    openLive(item) {
      this.$confirm('确定开启该直播间', '开启直播间', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { courseScheduleContentId, courseScheduleDateId } = item;
        const data = await axClient.live.insertCourseLiveRecord(
          {
            courseScheduleContentId,
            courseScheduleDateId,
          },
        );
        if (data) {
          this.$message.success('开启成功');
          this.getList();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  .header {
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    .l {
      display: flex;
      align-items: center;
      .label {
        font-weight: 500;
        font-size: 14px;
        margin-right: 12px;
        min-width: 50px;
      }
      .el-select {
        margin-right: 15px;
        flex: 1;
      }
    }
  }
}
</style>
